import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { GroupApiService } from "@app/shared/fleet/group/services/group-api.service";
import { PriceListApiService } from "@app/shared/revenue-management/price-lists/services/price-list-api.service";
import { ReservationSourceTypeApiService } from "@app/shared/revenue-management/reservation-source-types/services/reservation-source-type-api.service";
import { ReservationSourceParentApiService } from "@app/shared/revenue-management/reservation-source-parents/services/reservation-source-parent-api.service";
import { ReservationSourceApiService } from "@app/shared/revenue-management/reservation-sources/services/reservation-source-api.service";

/** Routes of the Revenue Management application, one entry per domain. */
export const revenueManagementRoutes: Routes = [
  {
    path: "price-lists",
    loadChildren: () => import("./domains/price-lists/price-lists.routes").then(r => r.priceListsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.PRICE_LIST.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.REVENUE_MANAGEMENT.PRICE_LISTS]) },
    // GroupApiService feeds the group selection panel and the CSV import.
    providers: [PriceListApiService, GroupApiService],
  },
  {
    path: "reservation-sources",
    loadChildren: () => import("./domains/reservation-sources/reservation-sources.routes").then(r => r.reservationSourcesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.RESERVATION_SOURCE.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.REVENUE_MANAGEMENT.RESERVATION_SOURCES]) },
    // GroupApiService feeds the economic conditions table.
    providers: [ReservationSourceApiService, GroupApiService],
  },
  {
    path: "reservation-source-types",
    loadChildren: () => import("./domains/reservation-source-types/reservation-source-types.routes").then(r => r.reservationSourceTypesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.RESERVATION_SOURCE_TYPE.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.REVENUE_MANAGEMENT.RESERVATION_SOURCE_TYPES]) },
    providers: [ReservationSourceTypeApiService],
  },
  {
    path: "reservation-source-parents",
    loadChildren: () => import("./domains/reservation-source-parents/reservation-source-parents.routes").then(r => r.reservationSourceParentsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.RESERVATION_SOURCE_PARENT.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.REVENUE_MANAGEMENT.RESERVATION_SOURCE_PARENTS]) },
    providers: [ReservationSourceParentApiService],
  },
];
